module.exports = __webpack_public_path__ + "static/media/avatars_all_3.385a2e87.png";